<template>
    <div class="flex flex-col">
        <UPageList class="text-sm flex-grow overflow-auto">
            <UPageCard
                v-for="(thread, index) in myCommentThreads"
                :key="thread.uuid"
                class="rounded-none cursor-pointer"
                :class="index + 1 < myCommentThreads.length ? 'border-b' : ''"
                :variant="detailedThread?.uuid === thread.uuid ? 'soft' : 'ghost'"
                :ui="{
                    container: index + 1 < myCommentThreads?.length ? 'sm:p-4' : 'sm:p-4 sm:pb-0'
                }"
                @click="() => toggleShowMore(thread)"
            >
                <template #body>
                    <resource-link-comment
                        :comment="thread.comments[0]"
                        :thread="thread"
                        @toggle-resolve-thread="toggleResolveThread"
                    />
                    <UButton
                        color="primary"
                        :value="thread.uuid"
                        variant="link"
                        :trailing-icon="!thread.resolved ? 'i-ph-circle-fill' : ''"
                        :ui="{ trailingIcon: 'size-2.5 -ml-1 -mt-1.5' }"
                        class="hover:underline"
                        :class="detailedThread?.uuid === thread.uuid ? 'underline' : ''"
                    >
                        {{ thread.comments.length > 1 ? thread.comments.length - 1 + ' svar' : 'Vis mer' }}
                    </UButton>
                </template>
            </UPageCard>
            <UPageCard
                v-if="myCommentThreads?.length === 0"
                class="rounded-none"
                variant="ghost"
                :ui="{
                    container: 'sm:p-4'
                }"
                description="Ingen kommentarer funnet.."
            />
        </UPageList>
        <div class="w-full flex-shrink-0">
            <USeparator type="solid"/>
            <UFormField
                label="Ny kommentar"
                class="px-6 py-2"
            >
                <div class="flex gap-2 justify-between">
                    <UInput
                        v-model="commentBody"
                        class="w-full"
                        placeholder="Skriv en ny kommentar..."
                        @keydown.enter="handleCreateThread"
                    />
                    <UButton
                        :disabled="commentBody.length === 0"
                        color="primary"
                        @click="handleCreateThread"
                    >
                        Send
                    </UButton>
                </div>
            </UFormField>
        </div>
    </div>
</template>

<script setup lang="ts">

import {CommentThread} from '@/comment/comment.service'
import ResourceLinkComment from '@/comment/ResourceLinkComment.vue'
import {nextTick, ref, watch} from 'vue'

const emit = defineEmits(['createThread', 'toggleResolveThread'])

const myCommentThreads = defineModel<CommentThread[]>('myCommentThreads', {default: []})
const detailedThread = defineModel<CommentThread>('detailedThread')

const commentBody = ref('')
const scrollToBottom = ref(false)

const toggleResolveThread = (thread: CommentThread) => {
    emit('toggleResolveThread', thread)
}

const toggleShowMore = (thread: CommentThread) => {
    if (detailedThread.value && detailedThread.value.uuid === thread.uuid) {
        detailedThread.value = undefined
    } else {
        detailedThread.value = thread
    }
}

const handleCreateThread = () => {
    if (commentBody.value === '') return

    emit('createThread', commentBody.value)
    commentBody.value = ''
    scrollToBottom.value = true
}

watch(myCommentThreads, () => {
    if (!scrollToBottom.value) return

    nextTick(() => {
        const latestThread = myCommentThreads.value[myCommentThreads.value.length - 1]
        const element = document.querySelector(`[value="${latestThread.uuid}"]`)
        element?.scrollIntoView()

        scrollToBottom.value = false
    })
})

</script>

<style scoped>

</style>